export default {
  // Page Header
  page_header: {
    title: "Вашите Канали",
    description: "На оваа страница можете да најдете информации за Lab Portal.",
    action_buttons: {
      refresh: {
        label: "Освежување на канали",
        tooltip: "Освежување на листата на канали",
      },
    },
  },

  // Content
  channel_card: {
    action_buttons: {
      start: "Стартирање",
      stop: "Запирање",
    },
  },
  channel: "канал",
  channels: "канали",
  online: "Онлајн",
  offline: "Офлајн",
  connected: "Поврзан",
  not_connected: "Не е поврзан",
  instrument_name: "Име на апарат",
  driver_id: "ID на драјвер",
  port: "Порт",

  // Empty State
  no_channels_title: "Нема достапни канали",
  no_channels_description:
    "Моментално нема конфигурирани канали. Ве молиме проверете ја врската или освежете.",
  refresh_channels: "Освежување на канали",
};
